export const HeorotThemeColors = {
  primary: {
    50: '#F2F8FC',
    100: '#D2E2EE',
    200: '#A5C5DD',
    300: '#77A7CC',
    400: '#4A8ABB',
    500: '#1D6DAA',
    600: '#175788',
    700: '#114166',
    800: '#0C2C44',
    900: '#061622',
    background: '#ECF1F8',
    numpad: '#ECF1F8',
  },
  contrast: {
    50: '#F2F8FC',
    100: '#D2E2EE',
    200: '#A5C5DD',
    300: '#77A7CC',
    400: '#4A8ABB',
    500: '#1D6DAA',
    600: '#175788',
    700: '#114166',
    800: '#0C2C44',
    900: '#061622',
  },
  neutral: {
    50: '#FAFAFA',
    100: '#F5F5F5',
    200: '#E5E5E5',
    300: '#D4D4D4',
    400: '#A3A3A3',
    500: '#737373',
    600: '#525252',
    700: '#404040',
    800: '#262626',
    900: '#171717',
  },
  success: {
    50: '#EEFFEE',
    100: '#DFFFDF',
    200: '#9BD69B',
    300: '#74BF74',
    400: '#4DA753',
    500: '#419641',
    600: '#398836',
    700: '#357A2C',
    800: '#286A20',
    900: '#1D4D06',
  },
  warning: {
    50: '#FFF4F6',
    100: '#F5EDE4',
    200: '#EAD1AC',
    300: '#E4AD65',
    400: '#E69331',
    500: '#DB7800',
    600: '#D07100',
    700: '#C56B00',
    800: '#B76200',
    900: '#A15500',
  },
  danger: {
    50: '#FFF4F6',
    100: '#FAE5E5',
    200: '#F0CAC5',
    300: '#ED7B6C',
    400: '#D14F36',
    500: '#D14117',
    600: '#C23718',
    700: '#B12B12',
    800: '#A5260B',
    900: '#971D00',
  },
};
